import { createReducer } from 'typesafe-actions';
import downloadActions from './actions';
import { DownloadState, DownloadTypes } from './types';

const INITIAL_STATE: DownloadState = {
  isLoading: false,
  isSuccess: false,
  error: 0,
};

export type RootDownloadActions =
  | ReturnType<typeof downloadActions.request>
  | ReturnType<typeof downloadActions.success>
  | ReturnType<typeof downloadActions.failure>;

const downloadReducer = createReducer<DownloadState, RootDownloadActions>(
  INITIAL_STATE,
  {
    [DownloadTypes.DownloadRequest]: () => {
      return {
        ...INITIAL_STATE,
        isLoading: true,
      };
    },
    [DownloadTypes.DownloadSuccess]: () => {
      return {
        isLoading: false,
        isSuccess: true,
        error: 0,
      };
    },
    [DownloadTypes.DownloadFailure]: (_, action) => {
      const { payload } = action;
      return {
        isLoading: false,
        error: payload,
        isSuccess: false,
      };
    },
  }
);

export default downloadReducer;
